<div *ngIf="spinner==true">
    <ngx-spinner size="medium" type="timer">
        <p style="font-size: 20px; color: white;padding-left:7%;">Loading...</p>
    </ngx-spinner>
</div>
<div class="container-fluid">
    <div class="card">
        <div class="card-header">
            <div class="d-flex justify-content-between">
                <h4 class="font-weight-bold text-dark py">ACTIVITY/TASK</h4>
                <div style="width:120px">
                    <button type="button" class="btn btn-block btn-danger" data-toggle="modal" data-target="#myModal"
                        (click)="setCurrentdate()">Add</button>
                </div>
            </div>

        </div>
        <div *ngIf="!tableshow" class="d-flex justify-content-center">
            <div class="loader"></div>
        </div>
        <div class="p-3">
            <div class="table-responsive" *ngIf="tableshow">
                <table class="table table-bordered display" [dtOptions]="dtOptions" datatable width="100%" cellspacing="0">
                    <thead>
                        <tr>
                            <th>Activity</th>
                            <th>Description</th>
                            <th>Date</th>
                            <th>Activity Type</th>
                            <th>Status</th>
                            <th>Show</th>
                            <th>Edit</th>
                            <th>Delete</th>
                            <!-- <th>Summary</th> -->
                        </tr>
                    </thead>
        
                    <tbody>
                        <tr *ngFor="let customer of customers">
                            <td style="min-width: 20px;">
                                {{customer.activity}}
                            </td>
                            <!-- <td style="min-width: 20px;">
                            {{customer.designation}}
                            </td> -->
                            <!-- <td style="min-width: 20px;">
                            {{customer.applied_role}}
                            </td> -->
                            <!-- <td style="min-width: 20px;">
                            {{customer.approval_status}}
                            </td> -->
                            <td style="min-width: 20px;">
                                {{customer.description}}
                            </td>
                            <td style="min-width: 20px;">
                                {{customer.date | date: 'dd-MM-yyyy'}} {{customer.time }}
                            </td>
                            <td style="min-width: 20px;">
                                {{customer.activity_type}}
                            </td>
                                <td style="min-width: 20px;">
                                    {{customer.status}}
                                </td>
        
                            <td><a data-toggle="modal" data-target="#showCM" class="btn btn-primary btn-circle btn-sm"
                                    (click)="buttonviewmeeting(customer,'show')">
                                    <i class="fas fa-flag"></i>
                                </a></td>
                            <td><button data-toggle="modal" data-target="#showCM" [disabled]="customer.status=='cancel'"
                                    class="btn btn-info btn-circle btn-sm" (click)="buttonviewmeeting(customer,'edit')">
                                    <i class="fas fa-check"></i>
                                </button></td>
                            <td><a  class="btn btn-danger btn-circle btn-sm"
                                    (click)="delete_CM(customer.id)">
                                    <i class="fas fa-trash"></i>
                                </a></td>
                                <!-- <td><a (click)="handleClickNavigate(customer.id)" class="btn btn-primary btn-sm">
                                    <i class="fas fa-eye"></i>
                                </a><td> -->
                            <ng-template #notShow>
                                <a *ngIf="customer.status=='cancel'">
                                    Cancelled
        
                                </a>
                            </ng-template>
                        </tr>
                    </tbody>
        
                </table>
            </div>
        </div>

        <div class="modal fade" id="myModal">
            <div class="modal-dialog modal-xl">
                <div class="modal-content">
                    <div class="card-danger">
                        <div class="card-header">
                            <h3 class="card-title">CREATE ACTIVITY/TASK</h3>
                            <button type="button" class="close" data-dismiss="modal"
                                (click)="Formreset()">&times;</button>
                        </div>

                        <div class="card-body">
                            <form class="register-form" [formGroup]='createmeetingform'
                                (ngSubmit)="postdata(createmeetingform)" autocomplete="off">
                                <div class="form-group row">
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label>Username / பயனர் பெயர்</label><span class="required "> *</span>
                                        <input pInputText type="text" class="form-control" formControlName="user_name"
                                            [(ngModel)]="user_name" readonly placeholder="Enter Username / பயனர் பெயர்">

                                    </div>
                                </div>
                                <input pInputText type="text" class="form-control" formControlName="user_id"
                                    [(ngModel)]="user_id" readonly placeholder="Enter UserId" style="display:none">

                                <div class="form-group row">
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label>Activity Date / இடுபணி தேதி<span class="required "> *</span></label>
                                        <input type="date" formControlName="activity_date" class="form-control"
                                            placeholder="Enter Activity Date / இடுபணி தேதி" required
                                            min="{{date | date:'yyyy-MM-dd'}}">
                                            <div style="color:red;" *ngIf="(createmeetingform.get('activity_date').touched && createmeetingform.get('activity_date').value=='')" >Please fill the field</div>
                                        <!-- <div  *ngIf="(createmeetingform.get('meeting_date').touched && createmeetingform.get('meeting_date').value=='')"
                                  class="invalid-msg" >Please fill this field</div> -->
                                        <!-- <div  class="invalid-msg" *ngIf="createmeetingform.get('meeting_date').untouched" [hidden]='hidden'>Please fill this field</div> -->
                                    </div>
                                    <div class="col-sm-6">
                                        <label>Activity Time / இடுபணி நேரம்<span class="required "> *</span></label>
                                        <input type="time" class="form-control" formControlName="activity_time"
                                            placeholder="Enter Activity Time / இடுபணி நேரம்" required>
                                                    <div style="color:red;" *ngIf="(createmeetingform.get('activity_time').touched && createmeetingform.get('activity_time').value=='')">Please fill
                                                        the field</div>
                                        <!-- <div  *ngIf="(createmeetingform.get('meeting_time').touched && createmeetingform.get('meeting_time').value=='')"
                            class="invalid-msg" >Please fill this field</div> -->
                                        <!-- <div  class="invalid-msg" *ngIf="createmeetingform.get('meeting_time').untouched" [hidden]='hidden'>Please fill this field</div> -->
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <div class="col-sm-12">
                                        <label>Activity / இடுபணி <span class="required "> *</span></label>
                                        <input pInputText type="text" class="form-control" formControlName="activity"
                                            placeholder="Enter Activity / இடுபணி" required>
                                                <div style="color:red;" *ngIf="(createmeetingform.get('activity').touched && createmeetingform.get('activity').value=='')">Please fill
                                                                                            the field</div>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <div class="col-sm-6">
                                        <label>Assigned To / இவர்களுக்கு ஒதுக்கப்பட்டது <span class="required ">
                                                *</span></label>
                                        <select type="text" class="form-control" #mySelect
                                            (change)="getChangeAssignedTo(mySelect.value);"
                                            formControlName="assigned_to"
                                            placeholder="Assigned To / இவர்களுக்கு ஒதுக்கப்பட்டது">
                                            <option value="" selected>Select Assigned To / இவர்களுக்கு ஒதுக்கப்பட்டது </option>
                                            <option >All District</option>
                                            <option>District</option>
                                            <option >Zone</option>
                                        </select>
                                        <div style="color:red;" *ngIf="(createmeetingform.get('assigned_to').touched && createmeetingform.get('assigned_to').value=='')">Please fill
                                                                                            the field</div>
                                    </div>
                                    <div class="col-sm-6" id="zones" style="display:none">
                                        <label class="form-label">Zone / மண்டலம் <span class="required ">
                                            *</span></label>
                                        <select type="text" class="form-control" formControlName="zone">
                                                <option value="" selected disabled hidden>Select Zone / மண்டலம்</option>
                                                <option *ngFor="let option of zones" (value)="option">
                                                    {{option}}</option>
                                        </select>
                                                                                <div style="color:red;"
                                                                                    *ngIf="(createmeetingform.get('zone').touched && createmeetingform.get('zone').value=='')">Please fill
                                                                                    the field</div>
                                    </div>
                                </div>
                                <div class="form-group row" id="Check1" style="display:none">
                                    <div class="col-sm-6">
                                        <label>Party District / கட்சி மாவட்டம்<span class="required ">
                                                *</span></label><br>
                                        <select class="form-control" formControlName="district" [(ngModel)]="district"
                                            #mydst (change)="getChangeToConstituey(mydst.value)">
                                            <option value="" selected disabled hidden>Select District</option>
                                            <option *ngFor="let option of district_list" (value)="option">
                                                {{option}}</option>
                                        </select>
                                        <div style="color:red;" *ngIf="createmeetingform.get('assigned_to').value=='District' && createmeetingform.get('district').touched && createmeetingform.get('district').value==''">Please fill
                                            the field</div>
                                    </div>
                                    <div class="col-sm-6">
                                        <label>Assembly constituency / சட்டமன்ற தொகுதி<span class="required ">
                                                *</span></label>
                                        <select class="form-control" formControlName="constituency"
                                            [(ngModel)]="OBConstituency">
                                            <option value="" selected disabled>Select constituency</option>
                                            <option *ngFor="let option of user_constituency" (value)="option">
                                                {{option}}</option>
                                        </select>
                                        <div style="color:red;" *ngIf="createmeetingform.get('assigned_to').value=='District'  && createmeetingform.get('constituency').touched && createmeetingform.get('constituency').value==''">
                                            Please fill
                                            the field</div>
                                        <!-- <div  class="invalid-msg" *ngIf="officebearerform.get('constituency').untouched" [hidden]='hidden'>Please select constituency</div> -->
                                    </div>

                                </div>

                                <div class="form-group row">
                                    <div class="col-sm-12">
                                        <label>Activity Description/ இடுபணி விரித்துரைத்தல் <span class="required ">
                                                *</span></label>
                                        <textarea class="form-control" placeholder="Enter Activity Description/ இடுபணி விரித்துரைத்தல்" formControlName="description"
                                            required></textarea>
                                            <div style="color:red;" *ngIf="createmeetingform.get('description').touched && createmeetingform.get('description').value==''">Please fill
                                                the field</div>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <div class="col-sm-6">
                                        <label>Activity Type/ இடுபணி மாதிப் படிவம் <span class="required ">
                                                *</span></label>
                                        <select class="form-control" #activity_type
                                            (change)="handleActivityTypeChange(activity_type.value)"
                                            formControlName="activity_type" required>
                                           <option value="" selected>Select Activity Type/ இடுபணி மாதிப் படிவம் </option>
                                            <option value="Poratam">Poratam</option>
                                            <option value="Mariyal">Mariyal</option>
                                            <option value="Nala Thittam">Nala Thittam</option>
                                            <option value="Others">Others</option>
                                        </select>
                                        <div style="color:red;" *ngIf="createmeetingform.get('activity_type').touched && createmeetingform.get('activity_type').value==''">Please fill
                                            the field</div>
                                    </div>
                                    <div class="col-sm-6" id="others" style="display:none">
                                        <label>Others<span class="required "> *</span></label>
                                        <input  type="text" class="form-control" formControlName="others"
                                            placeholder="Enter Others" >
                                            <div style="color:red;" *ngIf="createmeetingform.get('others').touched && createmeetingform.get('others').value === ''">Please fill
                                                the field</div>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <div class="col-sm-6">
                                        <label>Status/ சமுதாயப் படிநிலை <span class="required "> *</span></label>
                                        <select class="form-control" formControlName="status" required>
                                            <option value="" selected>Select Status/ சமுதாயப் படிநிலை</option>
                                            <option value="Open">Open</option>
                                            <option value="Inprogress">Inprogress</option>
                                            <option value="Completed">Completed</option>

                                        </select>
                                        <div style="color:red;" *ngIf="createmeetingform.get('status').touched && createmeetingform.get('status').value==''">Please fill
                                            the field</div>
                                    </div>
                                </div>
                                <br />


                                <div class="d-flex justify-content-center">
                                    <div style="width:200px">
                                        <button class="btn btn-danger btn btn-block" [disabled]="!createmeetingform.valid" >Create Activity</button>
                                    </div>
                                </div>

                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      


        <div class="modal fade" id="showCM">
            <div class="modal-dialog modal-xl">
                <div class="modal-content">
                    <div class="card-danger">
                        <div class="card-header">
                            <h3 class="card-title" id="card_title"></h3>
                            <button type="button" class="close" data-dismiss="modal">&times;</button>
                        </div>
                        <div class="card-body">
                            <form class="register-form" [formGroup]='editmeetingform'
                                (ngSubmit)="updatedata(editmeetingform,CM_id)" autocomplete="off">
                                <div class="form-group row">
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label>Username / பயனர் பெயர்</label><span class="required "> *</span>
                                        <input pInputText type="text" class="form-control"  formControlName="user_name"
                                            placeholder="Enter Username / பயனர் பெயர்" [value]="CM_name"
                                            readonly="readonly">

                                    </div>
                                     <input pInputText type="text" class="form-control" formControlName="user_id"
                                    [(ngModel)]="user_id" readonly placeholder="Enter UserId" style="display:none"> 
                                </div>

                              
                              
                                <div class="form-group row" *ngIf="!editfield">
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label>Activity Date / இடுபணி தேதி<span class="required "> *</span></label>
                                        <input pInputText type="date" class="form-control"
                                            formControlName="activity_date" [value]="CM_date"
                                            placeholder="Enter Activity Date / இடுபணி தேதி" readonly="readonly">

                                    </div>
                                    <div class="col-sm-6">
                                        <label>Activity Time / இடுபணி நேரம்<span class="required"> *</span></label>
                                        <input pInputText type="time" class="form-control"
                                            formControlName="activity_time" [value]="CM_time"
                                            placeholder="Enter Activity Time / இடுபணி நேரம்" readonly="readonly">

                                    </div>
                                </div>
                                <div class="form-group row" *ngIf="editfield">
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label>Activity Date / இடுபணி தேதி<span class="required "> *</span></label>
                                        <input  type="date" class="form-control" formControlName="activity_date" 
                                            placeholder="Enter Activity Date / இடுபணி தேதி" >
                                
                                    </div>
                                    <div class="col-sm-6">
                                        <label>Activity Time / இடுபணி நேரம்<span class="required "> *</span></label>
                                        <input  type="time" class="form-control" formControlName="activity_time" 
                                            placeholder="Enter Activity Time / இடுபணி நேரம்"  >
                                
                                    </div>
                                </div>

                                <div class="form-group row" *ngIf="!editfield">
                                    <div class="col-sm-12">
                                        <label>Activity / இடுபணி <span class="required "> *</span></label>
                                        <input pInputText type="text" class="form-control" formControlName="activity"
                                    [value]="CM_activity"
                                            placeholder="Enter Activity / இடுபணி" readonly>
                                    </div>
                                </div>

                                <div class="form-group row" *ngIf="editfield">
                                    <div class="col-sm-12">
                                        <label>Activity / இடுபணி <span class="required "> *</span></label>
                                        <input pInputText type="text" class="form-control" formControlName="activity" [value]="CM_activity"
                                            placeholder="Enter Activity / இடுபணி" >
                                    </div>
                                </div>

                                <div class="form-group row" *ngIf="!editfield">
                                    <div class="col-sm-12">
                                        <label>Activity Description/ இடுபணி விரித்துரைத்தல் <span class="required ">
                                                *</span></label>
                                        <textarea class="form-control" placeholder="Enter Activity Description/ இடுபணி விரித்துரைத்தல்" formControlName="description" readonly required [value]="CM_description"
                                            ></textarea>
                                    </div>
                                </div>
                                <div class="form-group row" *ngIf="editfield">
                                    <div class="col-sm-12">
                                        <label>Activity Description/ இடுபணி விரித்துரைத்தல் <span class="required ">
                                                *</span></label>
                                        <textarea class="form-control" formControlName="description"  required
                                            [value]="CM_description"></textarea>
                                    </div>
                                </div>

                                <div class="form-group row" *ngIf="!editfield">
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label>Activity Type/ இடுபணி மாதிப் படிவம் <span class="required ">
                                                *</span></label>
                                        <input pInputText type="text" class="form-control"
                                            formControlName="activity_type" [value]="CM_activity_type"
                                            placeholder="Enter Activity Type / இடுபணி மாதிப் படிவம்"
                                            readonly="readonly">

                                    </div>
                                    <div class="col-sm-6" id="others" *ngIf="CM_others !== ''&& CM_others !== null">
                                        <label>Others<span class="required "> *</span></label>
                                        <input pInputText type="text" placeholder="Enter Others" [value]="CM_others" class="form-control" formControlName="others"
                                            placeholder="Enter Others" required readonly>
                                    </div>
                                    
         
                                </div>
                                <div class="form-group row" *ngIf="!editfield">
                                                        <div class="col-sm-6" >
                                                            <label>Assigned To / இவர்களுக்கு ஒதுக்கப்பட்டது <span class="required ">
                                                                    *</span></label>
                                                            <input pInputText type="text" class="form-control" formControlName="assigned_to" [value]="CM_assigned_to"
                                                                placeholder="Enter Activity Time / இடுபணி நேரம்" readonly="readonly">
                                                        
                                                        </div>
                                                        
                                                                    <div class="col-sm-6" id="zones" *ngIf="CM_assigned_to ==='Zone'">
                                                                        <label class="form-label">Zone / மண்டலம் <span class="required ">
                                                                                *</span></label>
                                                                     
                                                                <input pInputText type="text" class="form-control" formControlName="zone" [value]="CM_zone"
                                                                                                                            placeholder="Enter Zone / மண்டலம்" readonly="readonly">
                                                        
                                                        </div>
                                                        </div>
                                <div class="form-group row" *ngIf="editfield">
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label>Activity Type/ இடுபணி மாதிப் படிவம் <span class="required ">
                                                *</span></label>
                                                <select class="form-control" [(ngModel)]="CM_activity_type" #activity_type (change)="handleActivityTypeChange(activity_type.value)"
                                                    formControlName="activity_type" required>

                                                    <option value="Poratam">Poratam</option>
                                                    <option value="Mariyal">Mariyal</option>
                                                    <option value="Nala Thittam">Nala Thittam</option>
                                                    <option value="Others">Others</option>
                                                </select>
                                        <!-- <input pInputText type="text" class="form-control" formControlName="activity_type" [value]="CM_activity_type"
                                            placeholder="Enter Activity Type / இடுபணி மாதிப் படிவம்" readonly="readonly"> -->
                                
                                    </div>
                                    <div class="col-sm-6" id="others" *ngIf="CM_others !== ''&& CM_others !== null">
                                        <label>Others<span class="required "> *</span></label>
                                        <input pInputText type="text" [value]="CM_others"  class="form-control" formControlName="others" placeholder="Enter Others" required>
                                    </div>

                                  
                                </div>
                                <div class="form-group row" *ngIf="editfield">
                                    <div class="col-sm-6">
                                        <label>Assigned To / இவர்களுக்கு ஒதுக்கப்பட்டது <span class="required ">
                                                *</span></label>
                                        <select type="text" class="form-control" [(ngModel)]="CM_assigned_to" #mySelect
                                            (change)="getChangeAssignedTo(mySelect.value);" formControlName="assigned_to"
                                            placeholder="Assigned To / இவர்களுக்கு ஒதுக்கப்பட்டது">

                                            <option>All District</option>
                                            <option>District</option>
                                            <option>Zone</option>
                                        </select>
                                    </div>
                                    <div class="col-sm-6" id="zones" *ngIf="CM_assigned_to === 'Zone'">
                                        <label class="form-label">Zone / மண்டலம் <span class="required ">
                                                *</span></label>
                                        <select type="text" class="form-control" formControlName="zone" [(ngModel)]="CM_zone">
                                            <option value="" selected disabled hidden>Select Zone / மண்டலம்</option>
                                            <option *ngFor="let option of zones" (value)="option">
                                                {{option}}</option>
                                        </select>
                                   
                                    </div>
                                </div>

                                <div class="form-group row" id="Check1" *ngIf="(CM_assigned_to === 'District' || CM_assigned_to === 'district') && !editfield">
                                    <div class="col-sm-6">
                                        <label>Party District / கட்சி மாவட்டம்<span class="required ">
                                                *</span></label><br>
                                                <input class="form-control" formControlName="district" [value]="district" readonly />
                                        <!-- <select class="form-control" formControlName="district" [(ngModel)]="district" #mydst
                                            (change)="getChangeToConstituey(mydst.value)">
                                            <option value="" selected disabled hidden>Select District</option>
                                            <option *ngFor="let option of district_list" [ngValue]="option">
                                                {{option}}</option>
                                        </select> -->
                                    </div>
                                    <div class="col-sm-6">
                                        <label>Assembly constituency / சட்டமன்ற தொகுதி<span class="required ">
                                                *</span></label>
                                        <input class="form-control" formControlName="constituency" [value]="CM_constituency" readonly />
                                        <!-- <select class="form-control" formControlName="constituency" [(ngModel)]="CM_constituency">
                                            <option value="" selected disabled>Select constituency</option>
                                            <option *ngFor="let option of user_constituency" [ngValue]="option">
                                                {{option}}</option>
                                        </select> -->
                                        <!-- <div  class="invalid-msg" *ngIf="officebearerform.get('constituency').untouched" [hidden]='hidden'>Please select constituency</div> -->
                                    </div>
                                
                                </div>
                                            <div class="form-group row" id="Check1" *ngIf="(CM_assigned_to === 'District' || CM_assigned_to === 'district') && editfield">
                                                <div class="col-sm-6">
                                                    <label>Party District / கட்சி மாவட்டம்<span class="required ">
                                                            *</span></label><br>
                                                    <select class="form-control" formControlName="district" [(ngModel)]="district" #mydst
                                                        (change)="getChangeToConstituey(mydst.value)">
                                                        <option value="" selected disabled hidden>Select District</option>
                                                        <option *ngFor="let option of district_list" [ngValue]="option">
                                                            {{option}}</option>
                                                    </select>
                                                </div>
                                                <div class="col-sm-6">
                                                    <label>Assembly constituency / சட்டமன்ற தொகுதி<span class="required ">
                                                            *</span></label>
                                                    <select class="form-control" formControlName="constituency" [(ngModel)]="CM_constituency">
                                                        <option value="" selected disabled>Select constituency</option>
                                                        <option *ngFor="let option of user_constituency" [ngValue]="option">
                                                            {{option}}</option>
                                                    </select>
                                                    <!-- <div  class="invalid-msg" *ngIf="officebearerform.get('constituency').untouched" [hidden]='hidden'>Please select constituency</div> -->
                                                </div>
                                            
                                            </div>

                                <div class="form-group row" *ngIf="!editfield">
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label>Status/ சமுதாயப் படிநிலை <span class="required "> *</span></label>
                                        <input pInputText type="text" class="form-control"
                                            formControlName="activity_type" [value]="CM_status"
                                            placeholder="Enter Status" readonly="readonly">

                                    </div>

                                </div>
                                
                                                <div class="form-group row" *ngIf="editfield">
                                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                                        <label>Status/ சமுதாயப் படிநிலை <span class="required "> *</span></label>
                                                    <select class="form-control" formControlName="status" required [(ngModel)]="CM_status">
                                                        <option value="Open">Open</option>
                                                        <option value="Inprogress">Inprogress</option>
                                                        <option value="Completed">Completed</option>
                                                    
                                                    </select>
                                                
                                                    </div>
                                                
                                                </div>

                                               

                                <div *ngIf="editfield" class="d-flex justify-content-center">
                                    <div style="width:200px">
                                        <button class="btn btn-danger btn btn-block">Update Activity</button>
                                    </div>
                                </div>

                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
